import React, { useEffect, useState ,useContext} from 'react';
import {
   Typography,
} from "@mui/material";
import PropTypes from 'prop-types'
import lottie from "lottie-web";
import * as config from "../../../next.config.js"
import { useTranslation } from 'next-i18next'
import FormHelperTxet from '@mui/material/FormHelperText'
import {CustomeBox} from "../StyledComponent/HintDialog1.style" 
import {CustomeDialogContent} from "../StyledComponent/HintDialog1.style" 
import {CustomeDialogActions} from "../StyledComponent/HintDialog1.style" 
import {BootstrapDialog} from "../StyledComponent/HintDialog1.style" 
import {Customebtn} from "../StyledComponent/HintDialog1.style" 
import {CustomeTextField} from "../StyledComponent/HintDialog1.style" 
import {CustomeFormControl2} from "../StyledComponent/HintDialog1.style" 
import { useCart } from "../../../context/cart/use-cart";
import CurrencyContext from '../../../context/currencyProvider'
import getOffers from "../../helpers/offers";
import style from '../../../styles/mystyle.module.css'
import { useRouter } from 'next/router'
import { getCookieValue, printLogs, buidlObject } from '../../helpers/helpers'
export default function PurchaseOrderConfirmDialog(props) {
  const { t } = useTranslation("common")

  const lottieDiv = React.useRef()
  const { getItem, items,getFeatureItem} = useCart();
  const router = useRouter()
const [loading,setLoading]=useState(false)
  const currencyCont= useContext(CurrencyContext)
  const [files,setFiles]=useState([])
  // useEffect(() => {
  // if( props.data&&props.data.files){
  //   setFiles(prev => [
  //     ...prev,
  //     ...  props.data.files.map(file=>
      
  //       Object.assign(file, {
  //         preview: URL.createObjectURL(file),
  //         index: files.length
  //       })
  //     )
  //   ])
  // }
      
 
  // }, [props])
  useEffect(() => {

    if (props.open) {
  
      setTimeout(() => {
      

       

      lottie.loadAnimation({
          container: lottieDiv.current,

          loop: true,
          autoplay: true,
          renderer: "svg",
          path: config.basePath + (props.type == "success" ? `/json/success.json` : "/json/error.json"),
          rendererSettings: {
            id: "imgSuccess"
          }
        })

        // lottie.play()
        return ()=>lottie.destroy()
    
      })
   

    }
    // console.log("destroy()============>")


// return ()=>lottieDiv.current.destroy()
// return ()=>lottie.destroy()






  }, [props.open])
  return (
    <>
      <BootstrapDialog
        open={props.open}
        maxWidth={"xs"}
        fullWidth
        onClose={props.onClose}
        PaperProps={{
          sx: { overflow: "visible", direction: "rtl", position: "relative" },

        }}
      >
        <CustomeBox
          ref={lottieDiv}
        ></CustomeBox>

        <CustomeDialogContent style={{ position: "relative", width: "100%" }}>
          <br />
          {props.title ? <Typography
            style={{ textAlign: "center", fontWeight: "bold", direction: "rtl", color: "#F52A59", padding: "10px 0px" }}
            variant="h3"
          >


            {props.title}



          </Typography> : ""}
          <div className={style.Adressandselectdiv} style={{direction:"rtl",paddingBottom:"10px" }}>

          {props.data &&props.data.files && props.data.files.length>0?
       <div className={style.BottomOrder} style={{display:"flex",overflow:"auto",justifyContent:"center"}}>

{ props.data.files.map(file=>{

return <>
<img
                          style={{ width: "150px", height: "100px" }}
                          src={file.preview}
                          // onLoad={() => {
                          //   URL.revokeObjectURL(file.preview);
                          // }}
                        />
</>
})}
                    
                     
                 
                      </div>:""}
          {props.data &&props.data.description !=null && props.data.description !=""?
       <div className={style.BottomOrder} style={{display:"flex"}}>

                        <div
                          className={
                            style.textaboutdoctor4+
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          {t("description")}
                        </div>
                        <div
                          className={
                            style.textaboutdoctor4 +
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          <div style={{display:"flex"}}>
                     {props.data.description }
                 

</div>
                        </div>
                      </div>:""}
          {props.data &&props.data.purchaseOrderType?
       <div className={style.BottomOrder} style={{display:"flex"}}>

                        <div
                          className={
                            style.textaboutdoctor4+
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          {t("OrderType")}
                        </div>
                        <div
                          className={
                            style.textaboutdoctor4 +
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          <div style={{display:"flex"}}>
                     {props.data.purchaseOrderType.name}
                 

</div>
                        </div>
                      </div>:""}
                      {props.data &&props.data.deliveryDate?
       <div className={style.BottomOrder} style={{display:"flex"}}>

                        <div
                          className={
                            style.textaboutdoctor4+
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          {t("BestTime")}
                        </div>
                        <div
                          className={
                            style.textaboutdoctor4 +
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          <div style={{display:"flex"}}>
                     {new Date(props.data.deliveryDate).toLocaleTimeString("ar", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric"
    })}
                 

</div>
                        </div>
                      </div>:""}
{props.data &&props.data.Address_from?
       <div className={style.BottomOrder} style={{display:"flex"}}>

                        <div
                          className={
                            style.textaboutdoctor4+
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          {t("address-from")}
                        </div>
                        <div
                          className={
                            style.textaboutdoctor4 +
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          <div style={{display:"flex"}}>
                     {props.data.Address_from.name + "-" + props.data.Address_from.address} 
</div>
                        </div>
                      </div>:""}
                      </div>
                      <div className={style.Adressandselectdiv} style={{direction:"rtl",paddingBottom:"10px" }}>
      
                      {props.data &&props.data.Address? 
                      <div className={style.stylesComfirmationpage} style={{direction:"rtl"}}>
                      <div className={style.BottomOrder} style={{display:"flex",padding:"8px 0px"}}>
                        <div
                          className={
                            style.textaboutdoctor4+
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                          {t("address-to")}
                        </div>
                        <div
                          className={
                            style.textaboutdoctor4 +
                            " " +
                            style.marginbottom +
                            " " +
                            style.paddingproduct+
                            " "+
                            style.Blod 
                          }
                        >
                   
             {props.data.Address.name + "-" + props.data.Address.address} 
                       
                     </div>   
                      </div>
                  
                      </div>    :""}  
                  
                      </div>
                      <div className={style.Adressandselectdiv} style={{direction:"rtl",paddingBottom:"10px" }}>
      
      {props.data &&props.data.deliveryPrice? 
      <div className={style.stylesComfirmationpage} style={{direction:"rtl"}}>
      <div className={style.BottomOrder} style={{display:"flex",padding:"8px 0px"}}>
        <div
          className={
            style.textaboutdoctor4+
            " " +
            style.marginbottom +
            " " +
            style.paddingproduct+
            " "+
            style.Blod 
          }
        >
       {t("DeliveryPrice") + "  =   "}
        </div>
        <div
          className={
            style.textaboutdoctor4 +
            " " +
            style.marginbottom +
            " " +
            style.paddingproduct+
            " "+
            style.Blod 
          }
        >
   
{ props.data.deliveryPrice&&  props.data.deliveryPrice.priceAfterDiscount  }
  {  props.data.deliveryPrice && props.data.deliveryPrice.currency &&props.data.deliveryPrice.currency[0].transCurrency.filter(
  i => i.language.code == router.locale
)[0].currencySymbol} 
       
     </div>   
      </div>
  
      </div>    :""}  
  
      </div>
              
        </CustomeDialogContent>
        <CustomeDialogActions
          justifyContent="center"
          style={{ justifyContent: "center" }}
        >
       

          <Customebtn
            variant={"contained"}
         
            loading={loading}
            onClick={ (e)=>{ 
              setLoading(true)
               props.btnOk()}}
          // onClick={handleSend}
          >
       
            {t("Confirm")}
          </Customebtn>
          <Customebtn
             color={"secondary"}
            variant={"contained"}
            // sx={{ backgroundColor: "#F52A59 !important" }}
            onClick={props.btnCancel}
            loading={loading}
          >
            {t("btnCancel")}

          </Customebtn>
        </CustomeDialogActions>
        {props.children}
      </BootstrapDialog>
    </>
  );
}
PurchaseOrderConfirmDialog.propTypes = {
  confirm: PropTypes.func,
  reject: PropTypes.func,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  text: PropTypes.string
}